import { get } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { ServiceConfig } from '@sales-center/common'

export async function getSearchResults(s: string) {
  const params = new URLSearchParams({ input: s })
  const response = await get(
    `${ServiceConfig.baseAPIUrl}/search?${params.toString()}`,
  )

  if (response.ok) {
    if (response.status === 204) {
      return { status: 'success', data: [] }
    }
    const result = await response.json()
    return { status: 'success', data: result }
  } else {
    toast.error('Failed to load search results.')
    return { status: 'failure', data: undefined }
  }
}
